<template>
  <v-container>
    <v-layout column>
      <v-flex mb-3>
        <h2 class="headline">Here you may create additional field</h2>
      </v-flex>
      <!--change formType to relevant-->
      <FormConstructor formType='awards-form'/>
    </v-layout>
  </v-container>
</template>

<script>
import FormConstructor from '@/components/shared/EvFormConstructor'
import { mapActions } from 'vuex'

export default {
  name: 'awards-form',
  components: {
    FormConstructor
  },
  methods: {
    ...mapActions(['getFormByType'])
  },
  created () {
    this.getFormByType('awards-form')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Awards/Settings/AwardsFormConstructor/index.vue